export const USERS_REQUEST = 'USERS_REQUEST'
export function usersRequest(filters) {
    return {
        type: USERS_REQUEST,
        filters
    }
}

export const USERS_SUCCESS = 'USERS_SUCCESS'
export function usersSuccess(users) {
    return {
        type: USERS_SUCCESS,
        users: users
    }
}

export const USERS_ERROR = 'USERS_ERROR'
export function usersError() {
    return {
        type: USERS_ERROR
    }
}

export const USER_REQUEST = 'USER_REQUEST'
export function userRequest(userId) {
    return {
        type: USER_REQUEST,
        userId: userId
    }
}

export const USER_SUCCESS = 'USER_SUCCESS'
export function userSuccess(user) {
    return {
        type: USER_SUCCESS,
        user: user
    }
}

export const USER_ERROR = 'USER_ERROR'
export function userError() {
    return {
        type: USER_ERROR
    }
}

export const ROLES_REQUEST = 'ROLES_REQUEST'
export function rolesRequest(noLoadingState) {
    return {
        type: ROLES_REQUEST,
        noLoadingState
    }
}

export const ROLES_REQUEST_SUCCESS = 'ROLES_REQUEST_SUCCESS'
export function rolesRequestSuccess(roles) {
    return {
        type: ROLES_REQUEST_SUCCESS,
        roles: roles
    }
}

export const ROLES_REQUEST_ERROR = 'ROLES_REQUEST_ERROR'
export function rolesRequestError() {
    return {
        type: ROLES_REQUEST_ERROR
    }
}

export const ROLE_REQUEST = 'ROLE_REQUEST'
export function roleRequest(roleId) {
    return {
        type: ROLE_REQUEST,
        roleId
    }
}

export const ROLE_REQUEST_SUCCESS = 'ROLE_REQUEST_SUCCESS'
export function roleRequestSuccess(role) {
    return {
        type: ROLE_REQUEST_SUCCESS,
        role
    }
}

export const ROLE_REQUEST_ERROR = 'ROLE_REQUEST_ERROR'
export function roleRequestError() {
    return {
        type: ROLE_REQUEST_ERROR
    }
}

export const ROLE_UPDATE = 'ROLE_UPDATE'
export function roleUpdate(roleId, body) {
    return {
        type: ROLE_UPDATE,
        roleId,
        body
    }
}

export const ROLE_UPDATE_SUCCESS = 'ROLE_UPDATE_SUCCESS'
export function roleUpdateSuccess() {
    return {
        type: ROLE_UPDATE_SUCCESS
    }
}

export const ROLE_UPDATE_ERROR = 'ROLE_UPDATE_ERROR'
export function roleUpdateError() {
    return {
        type: ROLE_UPDATE_ERROR
    }
}

export const ROLE_CREATE = 'ROLE_CREATE'
export function roleCreate(body) {
    return {
        type: ROLE_CREATE,
        body
    }
}

export const ROLE_CREATE_SUCCESS = 'ROLE_CREATE_SUCCESS'
export function roleCreateSuccess(newRoleId) {
    return {
        type: ROLE_CREATE_SUCCESS,
        newRoleId
    }
}

export const ROLE_CREATE_ERROR = 'ROLE_CREATE_ERROR'
export function roleCreateError() {
    return {
        type: ROLE_CREATE_ERROR
    }
}

export const CUSTOMERS_REQUEST = 'CUSTOMERS_REQUEST'
export function customersRequest() {
    return {
        type: CUSTOMERS_REQUEST
    }
}

export const CUSTOMERS_REQUEST_SUCCESS = 'CUSTOMERS_REQUEST_SUCCESS'
export function customersRequestSuccess(customers) {
    return {
        type: CUSTOMERS_REQUEST_SUCCESS,
        customers
    }
}

export const CUSTOMERS_REQUEST_ERROR = 'CUSTOMERS_REQUEST_ERROR'
export function customersRequestError() {
    return {
        type: CUSTOMERS_REQUEST_ERROR
    }
}

export const USER_UPDATE_REQUEST = 'USER_UPDATE_REQUEST'
export function userUpdateRequest(userId, userBody) {
    return {
        type: USER_UPDATE_REQUEST,
        userId,
        userBody
    }
}

export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export function userUpdateSuccess() {
    return {
        type: USER_UPDATE_SUCCESS
    }
}

export const USER_UPDATE_ERROR = 'USER_UPDATE_ERROR'
export function userUpdateError() {
    return {
        type: USER_UPDATE_ERROR
    }
}

export const USER_CREATE_REQUEST = 'USER_CREATE_REQUEST'
export function userCreateRequest(userBody) {
    return {
        type: USER_CREATE_REQUEST,
        userBody
    }
}

export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS'
export function userCreateSuccess(newUserId) {
    return {
        type: USER_CREATE_SUCCESS,
        newUserId
    }
}

export const USER_CREATE_ERROR = 'USER_CREATE_ERROR'
export function userCreateError() {
    return {
        type: USER_CREATE_ERROR
    }
}

export const USERS_DELETE_REQUEST = 'USERS_DELETE_REQUEST'
export function usersDeleteRequest(deleteBody) {
    return {
        type: USERS_DELETE_REQUEST,
        deleteBody
    }
}

export const USERS_DELETE_SUCCESS = 'USERS_DELETE_SUCCESS'
export function usersDeleteSuccess() {
    return {
        type: USERS_DELETE_SUCCESS
    }
}

export const USERS_DELETE_ERROR = 'USERS_DELETE_ERROR'
export function usersDeleteError() {
    return {
        type: USERS_DELETE_ERROR
    }
}

export const USERS_CHECK_MEMBERSHIP_REQUEST = 'USERS_CHECK_MEMBERSHIP_REQUEST'
export function usersCheckMembershipRequest(emails) {
    return {
        type: USERS_CHECK_MEMBERSHIP_REQUEST,
        emails
    }
}

export const USERS_CHECK_MEMBERSHIP_SUCCESS = 'USERS_CHECK_MEMBERSHIP_SUCCESS'
export function usersCheckMembershipSuccess(emailsMembership) {
    return {
        type: USERS_CHECK_MEMBERSHIP_SUCCESS,
        emailsMembership
    }
}

export const USERS_CHECK_MEMBERSHIP_ERROR = 'USERS_CHECK_MEMBERSHIP_ERROR'
export function usersCheckMembershipError() {
    return {
        type: USERS_CHECK_MEMBERSHIP_ERROR
    }
}

export const USERS_ADD_TO_CUSTOMER_REQUEST = 'USERS_ADD_TO_CUSTOMER_REQUEST'
export function usersAddToCustomerRequest(body) {
    return {
        type: USERS_ADD_TO_CUSTOMER_REQUEST,
        body
    }
}

export const USERS_ADD_TO_CUSTOMER_SUCCESS = 'USERS_ADD_TO_CUSTOMER_SUCCESS'
export function usersAddToCustomerSuccess() {
    return {
        type: USERS_ADD_TO_CUSTOMER_SUCCESS
    }
}

export const USERS_ADD_TO_CUSTOMER_ERROR = 'USERS_ADD_TO_CUSTOMER_ERROR'
export function usersAddToCustomerError() {
    return {
        type: USERS_ADD_TO_CUSTOMER_ERROR
    }
}

export const DELETE_CUSTOM_ROLES = 'DELETE_CUSTOM_ROLES'
export function deleteCustomRolesAction(body) {
    return {
        type: DELETE_CUSTOM_ROLES,
        body
    }
}
